// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {CSSProperties} from 'react';
import cn from 'classnames';
import {Link} from 'react-router-dom';
import {oculus_img_url} from '../../../hola/pub/ui/oculus_img_url';
import styles from './logo.module.less';

interface i_logo_props {
    to?: string;
    height?: number;
    variant?: 'full' | 'short' | 'stacked' | 'icon';
    dark?: boolean;
    cls?: string;
    clickid?: string;
    alt?: string;
}
export const Logo = (props: i_logo_props)=>{
    const {to = '/', height = 36, variant = 'full', dark, cls,
        clickid, alt = 'Site logo'} = props;
    const img = `logo/logo_${variant}${dark ? '_dark' : ''}.svg`;
    return <Link to={to} className={cn(styles.logo, cls)}
      data-clickid={clickid}
      style={{'--logo_height': `${height}px`} as CSSProperties}>
      <img src={oculus_img_url(img)} alt={alt}/>
    </Link>;
};
